// src/data/texts.js
export const skillsText = `Alat yang Saya Gunakan:
- VSCode
  Biasanya untuk coding website dan aplikasi antarmuka command-line.
- Git
  Membantu mengelola proyek saya dan berkolaborasi dengan programmer lain.
- Docker
  Mudah mengirim proyek ke orang lain tanpa menyebabkan kesalahan.

Framework yang Saya Gunakan:
- Laravel, ReactJS.

Bahasa yang Saya Gunakan:
- JavaScript, PHP, Lua.

Basis Data yang Saya Gunakan:
- MySQL/MariaDB, MongoDB, File teks, JSON.

Arsitektur:
- RESTful API, OOP.
`;

export const welcomeText = `Situs web ini dirancang untuk meniru lingkungan desktop di mana pengguna dapat berinteraksi dengan berbagai elemen seperti folder, file, dan tautan.

Fitur:
- Klik dua kali untuk membuka folder dan file.
- Mendukung gambar, video, file teks, dan tautan.
- Ubah ukuran jendela dengan menyeret sudut kanan bawah.
- Taskbar yang melacak jendela yang terbuka.
- Ganti Bahasa Inggris dan Indonesia menggunakan tombol bahasa di Taskbar
- Terminal emulator dengan perintah dasar (cd, ls, cat, clear, help)

Proyek ini adalah demonstrasi antarmuka desktop berbasis web modern, menggabungkan React dan Tailwind CSS untuk menciptakan pengalaman pengguna yang lancar dan interaktif.

Salam,
Roza.
`;

export const aboutwebsiteText = `Situs web ini dibuat menggunakan framework create-react-app dan TailwindCSS.
kebanyakan waktu yang saya habiskan untuk coding proyek ini adalah sistem file dan pengelolaan Window Container,
jadi saya cukup bangga dengan proyek ini karena saya membuat sebagian besar struktur dalam waktu 2 hari dan saya masih berencana untuk menambahkan fitur lebih lanjut pada situs web ini:

Ide Masa Depan untuk Situs Web Ini
- ContextMenu (Anda dapat membuat folder dan file txt dengan ini, juga menghapusnya.)
- Dukungan Seluler (saat menggunakan ponsel untuk mengakses situs ini, akan meniru perasaan android/ios.)
- Tambahkan Terminal (yang ada di taskbar masih placeholder.)
- Lokalisasi (masih dalam pengerjaan.)
Anda dapat menghubungi saya di Discord: shiniya_
`;

export const infoText = `Nama saya adalah Roza.
Saya lebih suka menggunakan PHP untuk membuat situs (terutama dengan framework Laravel).
Hobi saya adalah membaca dan menulis cerita, modif software, dan berkontribusi ke repositori orang lain.

Saya suka mengembangkan front end dengan React (saya entah mengapa tidak suka NextJS tapi berencana untuk mempelajarinya).

Saat ini menggunakan Arch Linux (Manjaro) sebagai Daily Driver dan saya menyukainya!
Discord : shiniya_`;

// export const markdownContent = `
//   ![fc13532303cfd8f4f32c1c3ed68aa1f2 1](https://github.com/shinyPy/shinyPy/assets/71328419/22b65ad6-f969-4790-9cb4-bdb88eee88a6)
//   <hr>
//   <h1 align="center">Kapan kerjanya?</h1>
//   <p align="left"> <img src="https://komarev.com/ghpvc/?username=shinypy&label=Profile%20views&color=0e75b6&style=flat" alt="shinypy" /> </p>

//   <img src="https://discord.c99.nl/widget/theme-2/656757505426325527.png"/>

// `;

export const changelogText = `Changelog:
  26/08/2024
  - Menambahkan lokalisasi.
  - Memperbaiki masalah di mana posisi transformasi pada desimal menyebabkan Window menjadi buram (thanks math.round).
  - Mengubah gaya taskbar dan File Manager dan mengubah namanya menjadi Thunar.
   28/08/2024
  - Tambah DateTime ke Taskbar
    21/02/2025
  - Membuat icon wrapping mirip dengan behavior icon Windows
  - Memisahkan File Explorer dan handling .exe
  - Menambahkan terminal dan membuat virtual FS untuk parsing initialFilesystem
  - Parsing filesystem secara langsung sehingga kita bisa mengaksesnya dan memodifikasinya untuk masa depan
  - kemungkinan akan menambahkan perintah mkdir dan nano
  17/05/2025
  - Memperbaiki navigasi folder untuk membuka folder spesifik dengan benar saat diklik dari desktop
  - Meningkatkan penanganan path di komponen FileExplorer
  - Membersihkan kode untuk meningkatkan keterbacaan dan pemeliharaan
  23/09/2025
  - Menambahkan konten informasi untuk file .txt proyek (info-tefaren.txt, info-wn.txt, info-news.txt, info-pt.txt)
  - Memperbarui pemetaan teks di FileUtils untuk mendukung deskripsi proyek yang dilokalkan
 `;

export const infoTefarenText = `TEFAREN adalah proyek yang dikembangkan dengan teknologi web modern yang bertujuan untuk peminjaman dan pengembalian barang.
Detail Proyek:
- Dibangun dengan React dan framework modern lainnya
- Di-deploy di platform Vercel

Tautan: https://fe-tefaren-v2.vercel.app/
`;

export const infoWnText = `Proyek Terjemahan AI Webnovel fokus pada penggunaan kecerdasan buatan untuk menerjemahkan webnovel secara efisien. Termasuk alat untuk terjemahan otomatis dan peningkatan kualitas. Jujur saja, proyek ini lebih untuk penggunaan pribadi karena saya adalah pembaca dan penulis webnovel.

Fitur Proyek:
- Mesin terjemahan bertenaga AI
- Dukungan untuk berbagai bahasa
- Alat penilaian kualitas
- Kemampuan pemrosesan batch

Proyek ini mendemonstrasikan integrasi AI dalam alur kerja terjemahan konten.
`;

export const infoNewsText = `Skatel News Mobile adalah aplikasi mobile berbasis Flutter untuk agregasi berita. Memberikan pengguna dengan pembaruan berita terbaru dalam antarmuka yang ramah pengguna.

Fitur Aplikasi:
- Pembaruan berita real-time
- Pemfilteran berita berdasarkan kategori
- Kemampuan membaca offline
- Notifikasi push
- Dibangun dengan Flutter untuk kompatibilitas lintas platform

Video demonstrasi tersedia di folder proyek.
`;

export const infoPtText = `CV TUNAS KEMBANG DJATI adalah kontraktor konstruksi terpercaya yang berbasis di Banjarbaru, spesialis dalam proyek konstruksi bangunan dan rekayasa sipil.

Ikhtisar Perusahaan:
- Didirikan: 21 Juli 2022
- Lokasi: Banjarbaru, Sidoarjo, Malang
- Tim: 20+ anggota profesional dengan pengalaman 3+ tahun

Layanan:
- Fabrikasi Cetakan (presisi dan berkualitas tinggi)
- Konstruksi Infrastruktur & Bangunan
- Solusi Rekayasa Industri

Pencapaian:
- 100+ proyek yang berhasil diselesaikan
- Bersertifikat dengan 6 standar ISO internasional (9001, 14001, 45001, 22000, 27001, 37001)
- Komitmen terhadap keberlanjutan lingkungan dan keselamatan (SMK3 PP 50/2012)

Ini adalah proyek yang dipesan untuk situs web profil perusahaan.

Website: https://teknikrekayasaindustri.co.id/
`;

export const infoPortoText = `Ini adalah situs portofolio lama saya, versi sebelumnya yang menampilkan karya saya sebagai pengembang web dan seniman 3D.

Fitur Portofolio:
- Pengenalan pribadi dengan informasi kontak
- Tampilan tumpukan teknologi yang komprehensif
- Latar belakang pendidikan
- Pertunjukan proyek GitHub
- Proyek unggulan termasuk TEFAREN dan E-Commerce Kardus
- Postingan blog di Medium

Portofolio ini mewakili karya pengembangan web awal saya dan demonstrasi keterampilan.

Tautan: https://fthlrzi.vercel.app/
`;
export const sitekalasText = `Proyek Komisi.
- Kalkulasi dan penyimpulan data satelit.
- Dibuat dengan Javascript dan Laravel
`;